import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { DeleteDialogComponent } from 'src/app/tarriff/dialog/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-delete-campaign-dialog',
  templateUrl: './delete-campaign-dialog.component.html',
  styleUrls: ['./delete-campaign-dialog.component.scss']
})
export class DeleteCampaignDialogComponent implements OnInit {
  yesFlag: boolean;
  apiUrl: any;
  urlDelete: string;

  constructor(public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private backendApiService: BackendApiService,
    private endPointService: EndpointsService) { }

  ngOnInit(): void {
    // this.apiUrl=this.endPointService.URL_DELETE_TARRIFF + '&sno=' + this.data.rowData.sno;
        this.yesFlag = true;
        this.urlDelete = this.data.urlDelete;
  }

  clickNo() {
    this.dialogRef.close();
  }

  clickYes() {
    this.backendApiService.callToApi(this.urlDelete).
    subscribe(response => {
      
      alert("Campaign Deleted Successfully");
      this.dialogRef.close();
    });
  }
}